import api from '@pray/shared/utils/api';

import type { DeleteWorkflowResponse } from './data/response';

type DeleteWorkflowProps = {
  artistId: string;
  workflowId: string;
};

export async function deleteWorkflow({ artistId, workflowId }: DeleteWorkflowProps): Promise<DeleteWorkflowResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!workflowId) throw new Error('Workflow ID is required');

  const url = `/web/studio/artists/${artistId}/workflows/${workflowId}`;

  const response = await api.executeDeleteRequest<DeleteWorkflowResponse>(url);
  return response.data;
}
